<template>
  <div class="hello">
    <h1>{{$t('example')}}</h1>
    {{$t('hello')}}
    <br/>
    <button @click="login()">login</button>
    <button @click="clearAll()">clearAll</button>
    <router-link :to="{ name: 'viewer', params: { id: 'index' } }">Go to index</router-link>
    |
    <router-link :to="{ name: 'viewer', params: { id: 'page2' } }">Go to Page2</router-link>

  </div>
</template>

<script>
import services from '@/services'
import { USER, PLAKA } from '@/store'
export const TYPE = services.component.normalizeType('HelloWorld')

export default {
  name: TYPE,
  data () {
    return {
      saludo: 'ADIOS',
      listenerOnChangeData: undefined
    }
  },
  computed: {
    getUsers () {
      let user = this.$store.getters[USER.GETTERS.GET_USER_TO_CONNECTION]('index')
      return user || 'SIN USUARIO'
    },
    filters () {
      return this.connectionStarted ? this.$store.getters[PLAKA.GETTERS.GET_FILTERS]() : {}
    }
  },
  methods: {
    login () {
      this.getConnection().loginInApp('ROOT', 'fernando')
    },
    clearAll () {
      this.getConnection().clearAll()
    }
  }
}
</script>

<style scoped lang="scss">
.hello {
  background: red;
}
</style>
